import * as React from "react";
import {ChildrenType} from "../../_definitions/styleteq";

interface Props {
    children?: ChildrenType;
}

const BreadcrumbsComponent = (props: Props) => {

    const {children} = props
    return (
        <div className="medium-6 column">
            <nav aria-label="You are here:" role="navigation" className="mt-1 mb-1">
                <ul className="breadcrumbs">
                    {children}
                </ul>
            </nav>
        </div>
    );
};

export default BreadcrumbsComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx